// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2gp67","legacyBtn":"MutateMid_legacyBtn__3d-ue"};